import { render, staticRenderFns } from "./GuiasManuaisModal.vue?vue&type=template&id=6d59a87b&scoped=true&"
import script from "./GuiasManuaisModal.vue?vue&type=script&lang=js&"
export * from "./GuiasManuaisModal.vue?vue&type=script&lang=js&"
import style0 from "./GuiasManuaisModal.vue?vue&type=style&index=0&id=6d59a87b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d59a87b",
  null
  
)

export default component.exports